import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import IconContainer from 'LegacyWeployDesignLanguage/icons/IconContainer';

const StyledEmptyStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: ${props => props.theme.spacing[8]};
`;

const StyledIconContainer = styled.div`
  margin-bottom: ${props => props.theme.spacing[2]};
`;

const StyledDescription = styled.div`
  text-align: center;
  ${props => props.theme.typography.body1}
`;

const EmptyState = ({
  description,
  title,
  icon,
  iconSize,
}) => (
  <StyledEmptyStateWrapper>
    {
      icon ? (
        <StyledIconContainer>
          <IconContainer svg={icon} size={IconContainer[iconSize]} />
        </StyledIconContainer>
      ) : null
    }
    { title ? <h6>{title}</h6> : null }
    <StyledDescription>{description}</StyledDescription>
  </StyledEmptyStateWrapper>
);

EmptyState.ICON_SMALL = IconContainer.SMALL;
EmptyState.ICON_MEDIUM = IconContainer.MEDIUM;
EmptyState.ICON_LARGE = IconContainer.LARGE;

EmptyState.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string,
  icon: PropTypes.node,
  iconSize: PropTypes.string,
};

EmptyState.defaultProps = {
  description: null,
  title: null,
  icon: null,
  iconSize: null,
};

export default EmptyState;
